import React from "react";
import styles from "./Header.module.css";

import GMallIcon from "./../../../../assets/images/icons/GMall.png";
import { ReactComponent as BackIcon } from "./../../../../assets/svg/back-icon.svg";
import { LangLink } from "../../../components/LangLink/LangLink";

const Header = (props) => {
  const { url = "/", label = null, onClose = null } = props;
  return (
    <div className={`${styles.Header} ${onClose ? styles.Normal : ""}`}>
      {onClose ? (
        <div onClick={() => onClose()} className={styles.BacklinkContainer}>
          <BackIcon className={styles.BackIcon} />
        </div>
      ) : (
        <LangLink to={url} className={styles.BacklinkContainer}>
          <BackIcon className={styles.BackIcon} />
        </LangLink>
      )}
      {!label && (
        <img
          src={GMallIcon}
          width={76}
          height={45}
          className={styles.GMall}
          alt="gmall"
        />
      )}
      {label && <div className={styles.Text}>{label}</div>}
    </div>
  );
};

export default Header;
